import { render } from "./gang-send-sms.vue?vue&type=template&id=332364c4"
import script from "./gang-send-sms.vue?vue&type=script&lang=js"
export * from "./gang-send-sms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__